
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MenuItems } from './menu-items/menu-items';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalBasicComponent } from './modal-basic/modal-basic.component';
import { TagInputModule } from 'ngx-chips';
import { ToastrModule } from 'ngx-toastr';
import { NgSelectModule} from '@ng-select/ng-select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { SpinnerComponent } from './spinner/spinner.component';
import { RequestSpinnerComponent } from './request-spinner/request-spinner.component';
import { AccordionComponent } from './accordion/accordion.component';
import { CheckboxFilterComponent } from './checkbox-filter/checkbox-filter.component';
import { ColorHighlightDirective } from './directives/color-highlight.directive';
import { ArrowPipe } from './pipes/arrow.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SafePipe } from './safe-pipe/safe.pipe';
import { UserRoleDirective } from './directives/user-role.directive';

import { CharacteristicSpecificationComponent } from './characteristic-specification/characteristic-specification.component';
import { CreateEntityComponent } from './create-entity/create-entity.component';
import { CustomEncoder} from './encoders/custom-encoder';
import { DetailComparisonComponent } from './detail-comparison/detail-comparison.component';
import { DataAdministrationService } from '../data-administration/services/data-administration-service';
import { ImportEntityDetailComponent } from './import-entity-detail/import-entity-detail.component';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { CreateValueMappingComponent } from './create-value-mapping/create-value-mapping.component';

@NgModule({
  imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      NgbModule,
      TagInputModule,
      NgSelectModule,
	  NgxDatatableModule,
	  AngularEditorModule,
	  FontAwesomeModule,
	  ToastrModule.forRoot(),
	  TooltipModule.forRoot(),
	  TranslateModule
  ],
  entryComponents: [
	  CharacteristicSpecificationComponent,
	  ConfirmationModalComponent,
	  CreateEntityComponent,
	  CreateValueMappingComponent,
	  DetailComparisonComponent,
	  ImportEntityDetailComponent
  ],
  declarations: [
	  LoadingSpinnerComponent,
      SpinnerComponent,
      ModalBasicComponent,
      RequestSpinnerComponent,
      AccordionComponent,
      CheckboxFilterComponent,
      ColorHighlightDirective,
	  ArrowPipe,
	  SafePipe,
	  UserRoleDirective,
	  CharacteristicSpecificationComponent,
	  CreateEntityComponent,
	  DetailComparisonComponent,
	  ImportEntityDetailComponent,
	  ConfirmationModalComponent,
	  CreateValueMappingComponent
  ],
  exports: [
      ColorHighlightDirective,
	  LoadingSpinnerComponent,
      SpinnerComponent,
	  NgbModule,
	  AngularEditorModule,
      FormsModule,
	  ReactiveFormsModule,
      ModalBasicComponent,
      TagInputModule,
      NgSelectModule,
	  NgxDatatableModule,
      RequestSpinnerComponent,
      AccordionComponent,
      CheckboxFilterComponent,
	  ArrowPipe,
	  SafePipe,
	  TranslateModule,
	  FontAwesomeModule,
	  TooltipModule,
	  UserRoleDirective,
	  CharacteristicSpecificationComponent,
	  CreateEntityComponent,
	  CreateValueMappingComponent,
	  DetailComparisonComponent
  ],
  providers: [
	  CustomEncoder,
	  DataAdministrationService,
      MenuItems
  ]
})
export class SharedModule { }
